import profileUtils from '../../repositories/profileUtils'

/**
 *
 * @param {*} component
 */
let mounted = (component)=>{
    component.getSavedPayments();
    component.getPayMethods();
}
/**
 *
 * @param {*} component
 * @param {*} data
 */
let addCard =(component,data)=> {
    component.savedPayments.push(data);
    if (data.paymentTypeId === 98) {
        component.hasCedyna = true;
        component.getPayMethods();
    }
}
/**
 *
 * @param {*} component
 * @param {*} PaymentService
 */
let getPayMethods = (component,PaymentService)=> {
    let self = component;
    PaymentService.getAllowedPaymentTypes({ orderType: 'PROFILE' }).then(
        function(response) {
            if (self.hasCedyna) {
                response = response.filter(function(payTypes) {
                    return payTypes.id !== 98;
                });
            }
            self.payTypes = [];
            response.map(function(v, k) {
                self.payTypes.push({
                    name: v.ofsId,
                    localName: v.localizedName,
                    id: v.id
                });
            });
        }
    );
}
/**
 *
 * @param {*} component
 * @param {*} PaymentService
 */
let getSavedPayments=(component,PaymentService)=> {
    let self = component;
    PaymentService.getSavedPayments().then(function(r) {
        r.map(function(v, k) {
            if (v.paymentTypeId === 98) {
                self.hasCedyna = true;
            }
            v.class = self.getTypeById(v.paymentTypeId);
            v.lastFour = v.paymentNumber.substr(-4);
            self.savedPayments.push(v);
        });
    });
}
/**
 *
 * @param {*} component
 * @param {*} payment
 * @param {*} PaymentService
 */
let deleteSavedPayment =(component,payment,PaymentService)=> {
    let self = component;
    let confirmation = window.confirm(component.sharedStrings.generic.delete_agreement);
    if (payment.paymentTypeId === 98) {
        component.hasCedyna = false;
        component.getPayMethods();
    }
    if (confirmation === true) {
        PaymentService.deleteSavedPayment(payment.bePaymentTypeId).then(
            function(response) {
                //remove it from view
                self.savedPayments = self.savedPayments.filter(
                    saved => saved.bePaymentTypeId !== payment.bePaymentTypeId
                );
                profileUtils.publishAnalytics(
                    self.$analytics.category.payments,
                    'method',
                    'deleted'
                );
            }
        );
    }
}
/**
 *
 * @param {*} id
 * @param {*} PaymentType
 */
let getTypeById=(id,PaymentType)=> {
    return Object.keys(PaymentType)
        // eslint-disable-next-line security/detect-object-injection
        .find(key => PaymentType[key] === id)
        .toLowerCase();
}
/**
 *
 * @param {*} component
 * @param {*} type
 */
let getActiveType=(component,type)=> {
    return type === component.selectedType;
}
/**
 *
 * @param {*} component
 * @param {*} id
 */
let cardClass=(component,id)=> {
    return component.getTypeById(id);
}

export default {
    addCard:addCard,
    getPayMethods:getPayMethods,
    getSavedPayments:getSavedPayments,
    deleteSavedPayment:deleteSavedPayment,
    getTypeById:getTypeById,
    getActiveType:getActiveType,
    cardClass:cardClass,
    mounted:mounted
};
